import { ENVIRONMENT_CONFIG } from './environmentConfig';

export const API_ENDPOINTS = {
  USER: {
    LOGIN: 'user-management/login',
    FORGET_PASSWORD: 'user-management/forgot-password',
    CHANGE_PASSWORD: 'user-management/change-password',
    ACTIVATE_ACCOUNT: 'user-management/activate',
    CREATE_USER: 'user-management/register',
    DELETE_USER: 'user-management/userDelete',
    LOCK_UNLOCK_USER: 'user-management/lockUnLock',
    USER_DETAILS: 'user-management/getUsers',
    SEND_LOGIN_OTP: 'user-management/login-step-2',
    SEND_FORGET_PASSWORD_OTP: 'user-management/forgot-password-otp-verified',
    GET_AUDIT_LOG: 'user-management/audit-log',
    GET_ROLES: 'access-management/getRoles',
    CREATE_ROLES: 'access-management/addRole',
    EDIT_ROLES: 'access-management/editRole',
    EDIT_USER: 'user-management/editUser',
    DELETE_ROLES: 'access-management/deleteRole',
    UPDAGE_PERMISSION_GRID: 'access-management/updateRolePermission',
    GET_PERMISSIONS: 'access-management/getPermissions',
    GET_ROLE_PERMISSIONS: 'access-management/getRolePermission',
    RESET_PASSWORD: 'user-management/reset-password',
    RESEND_OTP: 'user-management/resend-login-otp',
    RESEND_FORGET_OTP: 'user-management/resend-rest-password-otp',
    GET_PROFILE_DETAILS: 'user-management/getProfile',
    UPDATE_PROFILE_DETAILS: 'user-management/updateProfile',
    UPDATE_PROFILE_PICTURE: 'user-management/updateProfilePicture',
    GET_PROFILE_PICTURE: 'user-management/getProfileImage',
    DELETE_PROFILE_PICTURE: 'user-management/deleteProfileImage',
    RESEND_ACTIVATION_EMAIL: 'user-management/resend-activation-email',
    INSPECTOR_USERS: 'user/list',
    REGISTER_CANDIDATE: 'user-management/register-external-user',
  },
  TASK: {
    GET_TASK_LIST: 'tasks/list',
    GET_TASK_TYPE_LIST: 'tasks/taskTypes/list',
    GET_TASK_OVERVIEW: 'task/overview',
    GET_TASK_TIMELINE: 'task/timeline',
    GET_TASK_COUNT: 'task/count',
    CREATE_TASK: 'tasks',
    DUPLICATE_TASK: 'tasks',
    UPDATE_TASK: 'tasks',
    DELETE_TASK: 'tasks',
    UPSERT_TASK: 'tasks/upsert',
    GET_RECURRENT_TASKS: 'task/recurrent/overview',
    DELETE_RECURRENT_TASKS: 'tasks/recurrent',
    GET_DYNAMIC_FIELDS: 'tasks/task/subtype/:id/getTaskCreationFields',
    GET_TASK_TYPES: 'tasks/task/types',
    GET_LEGAL_METRO_TASK_TYPES: 'tasks/task/type/:id/subtypes',
  },
  NEWS: {
    CREATE_NEWS: 'news',
    UPDATE_NEWS: 'news',
    DELETE_NEWS: 'news',
    GET_PUBLIC_NEWS: 'public/news/list',
    GET_PUBLIC_NEWS_BY_ID: 'public/news',
  },
  PRESENTATION: {
    GET_PRESENTATION_LIST: 'products/list',
    GET_PUBLIC_PRESENTATIONS: 'public/products',
    PRESENTATIONS: 'products',
    GET_PRESENTATIONS_BY_MAIN_PRODUCT: 'products/main-product',
    GET_PRODUCT_PRESENTATIONS: 'product/presentations',
    GET_PRODUCT_PRESENTATION_PRICE_RECORDS: 'product/presentations/price-records',
    UPSERT_PRESENTATION: 'products/upsert',
    RESTORE_PRESENTATION: 'products/:id/restore',
    GET_PRESENTATION_COUNT: 'product/count',
    GET_PUBLIC_LATEST_PRICES: 'public/latest-prices',
    UPLOAD_BULK: 'products/import-excel',
    DOWNLOAD_TEMPLATE: 'products/template/download',
    GET_CONVERTIBLE_UNIT_GROUPS: 'products/convertible-unit-groups',
  },
  BASKET: {
    GET_BASKET_LIST: 'baskets/list',
    GET_PUBLIC_BASKETS: 'public/baskets/list',
    BASKETS: 'baskets',
    UPDATE_BASKET: 'baskets/update',
    DELETE_BASKET: 'baskets',
    RESTORE_BASKET: 'baskets',
  },
  PRODUCT_CATEGORY: {
    GET_PRODUCT_CATEGORY_LIST: 'product-categories/list',
    PRODUCT_CATEGORY: 'product-category',
    PRODUCT_CATEGORIES: 'product-categories',
    RESTORE_PRODUCT_CATEGORY: 'product-categories',
  },
  LOCATION: {
    GET_LOCATION_LIST: 'locations/list',
    GET_PUBLIC_LOCATIONS: 'public/locations/list',
    GET_BY_COORDINATES: 'locations/by-coordinates',
    GET_GEOJSON: 'locations/geojson',
    GET_DISTRICTS_GEOJSON: 'locations/districts-geojson',
  },
  ESTABLISHMENT: {
    GET_ESTABLISHMENT_LIST: 'establishments/list',
    GET_ESTABLISHMENT_COUNT: 'establishment/count',
    ESTABLISHMENT: 'establishments',
  },
  ESTABLISHMENT_TYPE: {
    GET_ESTABLISHMENT_TYPE_LIST: 'establishments/establishment-types/list',
    ESTABLISHMENT_TYPE: 'establishments/establishment-types',
  },
  PRICE_CONFIG: {
    GET_PRICE_CONFIG_LIST: 'alert-configs/list',
  },
  ALERT_CONFIG: {
    ALERT_CONFIGS: 'alert-configs',
    GET_ALERT_CONFIG_LIST: 'alert-configs/list',
  },
  INSPECTION: {
    INSPECTIONS: 'inspections',
    GET_INSPECTION_LIST: 'inspections/list',
    GET_PUBLIC_INSPECTION_COUNT: 'public/inspection/count',
    GET_INSPECTION_DETAIL: 'inspection/detail',
    DOWNLOAD_INSPECTION_DETAIL: 'inspection/detail/download',
    GET_INSPECTION: 'inspection',
  },
  ALERT: {
    GET_ALERT_LIST: 'alert-configs/alert/list',
    GET_ALERT_MAP_DATA: 'alert/map-data',
  },
  CITIZEN_INSPECTION: {
    GET_CITIZEN_INSPECTION_DETAIL: 'inspection/citizen/detail',
    DOWNLOAD_CITIZEN_INSPECTION_DETAIL: 'inspection/citizen/detail/download',
    GET_CITIZEN_INSPECTION: 'inspection',
  },
  CITIZEN_PRICE: {
    CITIZEN_PRICE_STATUS_UPDATE: 'prices',
    CITIZEN_PRICE_STATUS_UPDATE_BULK: 'prices/status/bulk',
  },
  PRICE: {
    PRICE: 'prices',
    PRICES: 'prices',
    GET_PRICE_LIST: 'prices/list',
    GET_PUBLIC_PRICES: 'public/price/list',
    DOWNLOAD_PRICE_RECORDS: 'public/price/list/download',
    GET_PUBLIC_PRICE_LOOKUP: 'public/price-lookup',
    GET_ALL_PUBLIC_PRICES_BY: 'public/prices/locations-all',
    GET_PRICE_LOCATIONS: 'price/locations',
    GET_PRICE_INSTANCES: 'price-instances',
  },
  NEWSLETTER: {
    GET_PUBLIC_NEWSLETTER: 'public/newsletter/list',
    GET_PUBLIC_NEWSLETTER_BY_ID: 'public/newsletter',
    POST_GENERATED_REPORT: 'public/newsletter/table',
    POST_GENERATED_GRAPH: 'public/newsletter/graph',
    POST_SAVE_NEWSLETTER: 'newsletter/create',
    NEWSLETTER: 'newsletter',
    // POST_PUBLISH_NEWSLETTER: `newsletter/id/publish`,
    // POST_UNPUBLISH_NEWSLETTER: `newsletter/id/unpublish`
  },
  NLP: {
    ASK: 'api/ask',
  },
  PERFORMANCE: {
    GET_PERFORMANCE: 'performance',
    GET_DETAILED_PERFORMANCE: 'performance/detailed',
  },
  DASHBOARD: {
    GET_USER_COUNT: 'user/count',
    GET_PRODUCT_COUNT: 'product/count',
    GET_PUBLIC_CITIZEN_BASIC_STATS: 'public/citizen/basicStats',
  },
  SIMPAH: {
    UPSERT: 'simpah/upsert',
    GET_PRODUCT_PROFIT: 'simpah/getProductProfit',
  },
  ANALYSIS: {
    GET_PUBLIC_PRODUCT_AVERAGE: 'public/product/average',
    GET_PUBLIC_PRICE_AVERAGE: 'public/price/average',
    GET_PRICE_CHANGE: 'public/price/change',
    GET_PUBLIC_PRICE_CHANGE: 'public/price-change',
    GET_PRICE_BREAKDOWN: 'price/breakdown',
    GET_BASKET_AVERAGE: 'basket/average',
    GET_PRODUCT_AVERAGE: 'price-comparision/products',
    GET_LOCATION_PRICE_COMPARISON: 'price-comparision/departments',
    GET_BASKET_PRICE_COMPARISON: 'price-comparision/baskets',
    GET_ESTABLISHMENT_PRICE_COMPARISON: 'price-comparision/establishments',
  },
  EXTERNAL_DATA: {
    POST_EXTERNAL_DATA_UPLOAD: 'cpi/upload',
    DOWNLOAD_EXTERNAL_DATA_TEMPLATE: 'cpi/template/download',
    SUBMIT_IHMA_PRICING: 'ihma-price',
    GET_IHMA_PRICE_BREAKDOWN: 'ihma-price/breakdown',
    GET_BCH_OVERLAY: 'cpi/overlay',
    GET_BCH_CONSTANTS: 'cpi/constants',
  },
  MAIN_PRODUCT: {
    POST_MAIN_PRODUCT: 'main-products',
    GET_MAIN_PRODUCT_LIST: 'main-products/list',
    PUT_MAIN_PRODUCT: 'main-products',
    DELETE_MAIN_PRODUCT: 'main-products',
    SYNC_MAIN_PRODUCT: 'main-products',
    RESTORE_MAIN_PRODUCT: 'main-products',
  },
};

export const BASE_URL = {
  ACCESS_MANAGEMENT_BASE: ENVIRONMENT_CONFIG.ACCESS_MANAGEMENT_SERVICE,
  CONSUMER_PRICE_BASE: ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE,
  ANALYSIS_SERVICE_BASE: ENVIRONMENT_CONFIG.ANALYSIS_SERVICE,
  NLP_SERVICE_BASE: ENVIRONMENT_CONFIG.NLP_SERVICE,
};
